import axiosAgsc from "@/store/axiosAgsc";
const resource = "/HashInspection";

export default {
  GetHashVisibilityHashDetail: (hash: any, payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/GetHashVisibilityHashDetail?hash=${hash}`, payload);
  },
  getHashInformationPage: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/GetHashInformationPage`, payload);
  },
};
